import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import styled from "styled-components"
import Color from "../../../../../../../style/enum/color"

interface IProps {
  onClick: (ev: React.MouseEvent<HTMLButtonElement>) => void
}

export const AddButton = ({ onClick }: IProps) => (
  <Add onClick={onClick} type="button">
    <Icon icon={faPlus} /> 選択肢を追加
  </Add>
)

export const DeleteButton = ({ onClick }: IProps) => (
  <Delete type="button" onClick={onClick}>
    <FontAwesomeIcon icon={faTimes} />
  </Delete>
)

const Add = styled.button`
  appearance: none;
  border: none;
  background-color: ${Color.TRANSPARENT};
  color: ${Color.BRAND};
  font-size: 0.8rem;
  cursor: pointer;
`

const Delete = styled.button`
  appearance: none;
  background-color: ${Color.TRANSPARENT};
  color: ${Color.LIGHT_GRAY};
  font-size: 0.6rem;
  cursor: pointer;
  border-radius: 100%;
  border: 1px solid ${Color.LIGHT_GRAY};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
`

const Icon = styled(FontAwesomeIcon)`
  font-size: 0.7rem;
  margin-right: 4px;
`
